
import { CallbackInfo } from '@/models/callback-info';
import { computed, ComputedRef, defineComponent, PropType, ref, Ref, WritableComputedRef } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'CallbackForm',
  props: {
    values: {
      type: Object as PropType<CallbackInfo>,
      required: true,
      default: null
    }
  },
  setup(
      props,
      {emit}) {

    const store = useStore();

    /**
     * Indicates whether the tos accepted field
     * is checked
     */
    let $tosAccepted = false;

    /**
     * Indicates whether the name field content is valid
     */
    const isNameValid: Ref<boolean | null> = ref(null);

    /**
     * Indicates whether the phone number field contains a
     * valid value
     */
    const isPhoneNumberValid: Ref<boolean | null> = ref(null);

    /**
     * Indicates whether the form was validated
     */
    const formWasValidated: Ref<boolean> = ref(false);

    const callbackFormData: WritableComputedRef<CallbackInfo> = computed({
      get(): CallbackInfo {
        return props.values || {} as CallbackInfo;
      },
      set(newValue: CallbackInfo): void {
        emit('update:values', newValue);
      }
    });

    /**
     * Checks the form data for validity and returns true when the form is valid.
     */
    function validate(): boolean {
      isNameValid.value = callbackFormData?.value?.name?.length >= 2;
      isPhoneNumberValid.value = callbackFormData?.value?.phoneNumber?.length >= 4;

      return isNameValid.value && isPhoneNumberValid.value && ($tosAccepted || false);
    }

    /**
     * Indicates whether the TOS have been accepted
     */

    const tosAccepted: WritableComputedRef<boolean> = computed({
      get(): boolean {
        return $tosAccepted;
      },
      set(newValue: boolean): void {
        $tosAccepted = newValue;
        const valid = validate();
        emit('form-changed', valid);
      }
    });

    /**
     * Returns the Terms-Of-Service / Privacy url
     */
    const tosUrl: ComputedRef<number> = computed(() => {
      return store.state.morticianSettings.privacyUrl || '#';
    });

    /**
     * Called when the form has changed
     */
    function formChanged(): void {
      emit('form-changed', validate());
      formWasValidated.value = true;
    }

    return {
      callbackFormData,
      tosAccepted,
      isNameValid,
      isPhoneNumberValid,
      formWasValidated,
      tosUrl,
      formChanged,
      validate
    };
  }
});
